import React from "react";
import OBrace from "../FakeTags/Brace/OBrace";
import CBrace from "../FakeTags/Brace/CBrace";
import BackgroundHTML1 from "../BackgroundHTML/BackgroundHTML1";
import BackgroundHTML2 from "../BackgroundHTML/BackgroundHTML2";
import "./Home.css";
import BackgroundJAVA from "../BackgroundHTML/BackgroundJAVA";
import BackgroundNode from "../BackgroundHTML/BackgroundNode";

// import BackgroundHTML3 from "../BackgroundHTML/BackgroundHTML3";
// import BackgroundHTML4 from "../BackgroundHTML/BackgroundHTML4";

function Home() {
  const intro = "I'm Raghav Aggarwal".split("");
  let c, timer;
  // setTimeout(() => {
  function loadName() {
    timer = setInterval(onTick, 100);
    c = 0;
  }
  function onTick() {
    const letter = document.querySelectorAll(".spa")[c];
    // console.log(letter.innerHTML);
    if (letter.innerHTML === "R") {
      letter.classList.add("letterR");
    } else {
      letter.classList.add("let");
    }
    ++c;
    if (c === intro.length) {
      clearInterval(timer);
      timer = null;
    }
  }

  // }, 3000);
  return (
    <div className="container" id="home">
      <BackgroundHTML1 />
      <BackgroundHTML2 />
      {/* <BackgroundHTML3 /> */}
      {/* <BackgroundHTML4 /> */}
      <BackgroundJAVA />
      <BackgroundNode />
      <div className="main">
        <span className="hey">Hey Folks</span>
        <OBrace />
        <div className="mainContent">
          <p className="greet">Welcome to my Portfolio Website</p>
          <h1 className="name">
            {loadName()}
            {intro.map((letter, index) => (
              <span key={index} className="spa">
                {letter}
              </span>
            ))}
          </h1>
          <p className="about">
            {/* I'm in my third year of studies at Chitkara University. I'm a quick
            study, and my tech stack consists of a variety of tools. I'm
            constantly interested in collaborating and working on new projects.
            <br /> */}
            I'm pursuing my B.E from Chitkara University in Computer Science. I
            am a Front-end Web Developer and hoping to become a full stack
            developer soon. I like coding as much as I like web development but
            I can say that I get intrigued from any technology that I start
            learning.
          </p>

          <a
            className="downloadResume"
            href="https://drive.google.com/file/d/1r5ZXy93loSWGR6EUycIR15LxmzzhvHdD/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            Download Resume
          </a>
          <a href="#contactMe" className="contactMe">
            Contact Me
          </a>
          <br />
        </div>
        <CBrace />
      </div>
    </div>
  );
}

export default Home;
